import { Button, Collapse, List, Space } from "antd"
import { Proposal } from "./proposalsModel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/pro-solid-svg-icons"
import AutomationFollowUpIcon from "./AutomationsFollowUpIcon"
import { red } from "@ant-design/colors"
import { faBoltSlash } from "@fortawesome/pro-duotone-svg-icons"
import { useDisableFollowUpMutation, useProposalEventsInvalidator } from "./proposalsQueries"

type Props = {
  latestProposal: Proposal
  onInvalidateJob: () => void
  redesign?: boolean
}

const ProposalRecipients = ({ latestProposal, onInvalidateJob, redesign = false }: Props) => {
  const proposalsTimelineInvalidator = useProposalEventsInvalidator()
  const disableFollowUp = useDisableFollowUpMutation(() => {
    onInvalidateJob()
    proposalsTimelineInvalidator.invalidate(latestProposal.id)
  })
  return <Collapse defaultActiveKey={1} style={{ marginBottom: '20px' }} items={[
    {
      key: 1,
      label: `Recipients (${latestProposal.recipients.length})`,
      children: <List
        locale={{ emptyText: redesign ? 'Nobody has been sent this proposal yet. Use Send Proposal to choose recipients.' : <></> }}
        dataSource={latestProposal.recipients}
        renderItem={(recipient) => <List.Item>
          <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <Space>
              <FontAwesomeIcon icon={faUser} />
              {recipient.email.toLowerCase()}
            </Space>
            { recipient.automationActive && <Space align="start">
              <span><AutomationFollowUpIcon /></span>
              <Space direction="vertical">
                <span>{ recipient.followUpsSent} out of { recipient.totalFollowUps} reminders sent </span>
                <span>Next reminder scheduled for: { recipient.nextFollowUpAt }</span>
                <Button 
                    type='default'
                    loading={false} 
                    onClick={() => disableFollowUp.mutate({proposalId: latestProposal.id, customerUserId: recipient.id})}>
                    <Space>
                      <FontAwesomeIcon icon={faBoltSlash} color={red.primary}/> 
                      Stop Sending Reminders
                    </Space>
                </Button>
              </Space>
            </Space>}
          </div>
        </List.Item>
        }
      />
    }
  ]} />
}

export default ProposalRecipients
